// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__I6i4l","input":"styles_input__Gxly2"};